import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import apiClient from '../Utils/apiClient';

export default function UserAnalytics() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [dateFrom, setDateFrom] = useState(searchParams.get("from") || "");
  const [dateTo, setDateTo] = useState(searchParams.get("to") || "");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchData = async () => {
    if (!email) {
      alert("Email is required");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email,
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
      };

      const res = await apiClient.post(
        "analytics/user-logs",
        payload
      );

      setData(res.data.data);
      setCurrentIndex(0);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchParams.get("email")) {
      fetchData();
    }
  }, []);

  const groupTimeline = () => {
    if (!data?.timeline) return [];

    const groups = [];
    let current = [];

    data.timeline
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      .forEach((item) => {
        if (item.step === 1 && current.length) {
          groups.push(current);
          current = [];
        }
        current.push(item);
      });

    if (current.length) groups.push(current);
    return groups;
  };

  const groups = groupTimeline().sort((a, b) => {
    const lastA = new Date(a[a.length - 1].created_at);
    const lastB = new Date(b[b.length - 1].created_at);
    return lastB - lastA;
  });

  const currentSession = groups[currentIndex] || [];
  const isFinalFailed = data?.final_status && !/success/i.test(data.final_status);

  return (
    <div className="main-panel">
      <div className="content-wrapper ivs-page">
        <div className="ivs-search-panel">
          <div className="ivs-search-row">
            <div>
              <label className="ivs-field-label">Email</label>
              <input
                type="text"
                placeholder="testemail@email.com"
                value={email}
                className="ivs-field"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="ivs-field-label">From</label>
              <input
                type="date"
                value={dateFrom}
                className="ivs-field"
                onChange={(e) => setDateFrom(e.target.value)}
              />
            </div>

            <div>
              <label className="ivs-field-label">To</label>
              <input
                type="date"
                value={dateTo}
                className="ivs-field"
                onChange={(e) => setDateTo(e.target.value)}
              />
            </div>

            <button onClick={fetchData} className="ivs-btn-primary" disabled={loading}>
              {loading ? "Loading…" : "Search"}
            </button>
          </div>
        </div>

        {data && (
          <div className="ivs-result-grid">
            <div className="ivs-panel">
              <h3 className="ivs-section-title">Result</h3>
              <div className="ivs-result-row">
                <span className="ivs-result-row__label">Email:</span>
                <span className="ivs-result-row__value">{data.email}</span>
              </div>
              <div className="ivs-result-row">
                <span className="ivs-result-row__label">Total Steps:</span>
                <span className="ivs-result-row__value">{data.total_steps}</span>
              </div>
              <div className="ivs-result-row">
                <span className="ivs-result-row__label">Final Status:</span>
                <span className={`ivs-result-row__value ${isFinalFailed ? 'is-failed' : 'is-success'}`}>
                  {data.final_status}
                </span>
              </div>
            </div>

            <div className="ivs-panel">
              <h3 className="ivs-section-title">Detail Session</h3>

              {currentSession.length === 0 && (
                <div className="ivs-empty-state">No steps recorded for this session</div>
              )}

              {currentSession.map((item, idx) => (
                <div className="ivs-step" key={idx}>
                  <div style={{ display: 'flex', gap: 16 }}>
                    <div style={{ minWidth: 56, fontWeight: 700, fontSize: 13, color: 'var(--ivs-text-muted)' }}>
                      Step {item.step}:
                    </div>
                    <div>
                      <div className="ivs-step__label">{item.label}</div>
                      {item.metadata?.company && (
                        <div className="ivs-step__meta">Company: {item.metadata.company}</div>
                      )}
                      <div className="ivs-step__meta">{new Date(item.created_at).toLocaleString()}</div>
                    </div>
                  </div>
                  <div className={`ivs-step__icon ${item.success ? 'is-success' : 'is-failed'}`}>
                    <i className={`bi ${item.success ? 'bi-check-lg' : 'bi-x-lg'}`}></i>
                  </div>
                </div>
              ))}

              {groups.length > 0 && (
                <div className="ivs-pagination">
                  <button
                    disabled={currentIndex === 0}
                    className="ivs-pagination__btn"
                    onClick={() => setCurrentIndex((prev) => prev - 1)}
                  >
                    Previous
                  </button>

                  <span className="ivs-pagination__label">
                    Session {currentIndex + 1} of {groups.length}
                  </span>

                  <button
                    className="ivs-pagination__btn"
                    disabled={currentIndex === groups.length - 1}
                    onClick={() => setCurrentIndex((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
